import { render, staticRenderFns } from "./v2overview-details.vue?vue&type=template&id=ae1ebf0a&"
import script from "./v2overview-details.vue?vue&type=script&lang=js&"
export * from "./v2overview-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports